import { render, staticRenderFns } from "./ProjectDetailToTag.vue?vue&type=template&id=19146df7&scoped=true"
import script from "./ProjectDetailToTag.vue?vue&type=script&lang=js"
export * from "./ProjectDetailToTag.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailToTag.vue?vue&type=style&index=0&id=19146df7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19146df7",
  null
  
)

export default component.exports